import React, { useContext, useState } from 'react';
import { FuelButton } from '@frete.com/fuel-react';
import AppContext from '@context';
import { OpenRateDriver } from '@utils/companyEvaluating/companyEvaluating';
import { finishJourney } from '@services/journeys';
import useAmplitude from '@hooks/useAmplitude';
import { ActionsPropsInterface } from './ActionsTypes';
import * as Styled from './ActionsStyles';

function Actions({ id }: ActionsPropsInterface) {
  const { amplitudeEvent } = useAmplitude();
  const [isLoading, setIsLoading] = useState(false);
  const { dispatch } = useContext(AppContext);

  function handleReject() {
    amplitudeEvent('modal_list_confirm_delivery_button_rejected');
    OpenRateDriver(id);
    dispatch({
      type: 'ui_modal_journey_waiting_confirm_delivery_set_show',
      payload: {
        isShow: false,
      },
    });
  }

  function handleConfirm() {
    amplitudeEvent('modal_list_confirm_delivery_button_confirmed');
    if (!isLoading) {
      setIsLoading(true);
      finishJourney(id)
        .then(() => {
          window.dispatchEvent(
            new CustomEvent('notificationShow', {
              detail: {
                isShow: true,
                heading: 'Confirmação de entrega salva com sucesso!',
                severity: 'success',
              },
            }),
          );
          dispatch({
            type: 'journeys_waiting_confirm_delivery_remove',
            payload: {
              journeyId: id,
            },
          });
        })
        .catch(() => {
          window.dispatchEvent(
            new CustomEvent('notificationShow', {
              detail: {
                isShow: true,
                heading: 'Não foi possível confirmar sua entrega!',
                severity: 'error',
              },
            }),
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }

  return (
    <Styled.Wrapper>
      <FuelButton
        size="small"
        variant="tertiary"
        onClick={() => handleReject()}
      >
        Não
      </FuelButton>
      <FuelButton
        size="small"
        onClick={() => handleConfirm()}
        isLoading={isLoading}
      >
        Sim
      </FuelButton>
    </Styled.Wrapper>
  );
}

export default Actions;
